import { render, staticRenderFns } from "./PrintTechniqueHeader.vue?vue&type=template&id=df60dd3a&scoped=true"
import script from "./PrintTechniqueHeader.vue?vue&type=script&lang=ts"
export * from "./PrintTechniqueHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintTechniqueHeader.vue?vue&type=style&index=0&id=df60dd3a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "df60dd3a",
  null
  ,true
)

export default component.exports